import { Components, Theme } from '@mui/material/styles';

export default (): Components<Theme>['MuiPaper'] => {
  return {
    styleOverrides: {
      root: { boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.16)!important' },
      rounded: {
        borderRadius: '8px'
      },
      elevation3: {
        boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.16)'
      }
    }
  };
};
